import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(1),
  },
  filterBuffer: {
    marginTop: theme.spacing(1),
  },
  dataContainer: {
    margin: `${theme.spacing(2)}px 0`,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    fontSize: 14,

    '& span': {
      marginLeft: 3,

      '&.bold': {
        fontWeight: 'bold',
      },
    },
  },

  buttonContainer: {
    marginTop: theme.spacing(2),
  },
  hidePrint: {
    '@media print': {
      display: 'none',
    },
  },
  btnCol: {
    marginTop: theme.spacing(2),
  },
  colTitle: {
    fontSize: 14,
  },
  btnRow: {
    marginTop: theme.spacing(1),

    '& button': {
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
  },
}));

export default useStyles;
